import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActuacionContractualState } from './actuacion-contractual.state';

export const selectActuacionContractualState =
  createFeatureSelector<ActuacionContractualState>('actuacionContractual');

export const selectAllActuacionesContractuales = createSelector(
  selectActuacionContractualState,
  state => state.actuacionesContractuales
);

export const selectActuacionContractualLoading = createSelector(
  selectActuacionContractualState,
  state => state.loading
);

export const selectActuacionContractualError = createSelector(
  selectActuacionContractualState,
  state => state.error
);

export const selectActuacionContractualCreating = createSelector(
  selectActuacionContractualState,
  state => state.creating
);

export const selectActuacionContractualUpdating = createSelector(
  selectActuacionContractualState,
  state => state.updating
);

export const selectActuacionContractualDeleting = createSelector(
  selectActuacionContractualState,
  state => state.deleting
);

export const selectActuacionContractualSearchResults = createSelector(
  selectActuacionContractualState,
  state => state.searchResults
);

export const selectSelectedActuacionContractual = createSelector(
  selectActuacionContractualState,
  state => state.selectedActuacionContractual
);

export const selectActuacionesContractualesToDisplay = createSelector(
  selectActuacionContractualSearchResults,
  selectAllActuacionesContractuales,
  (searchResults, actuacionesContractuales) => {
    return searchResults.length > 0 ? searchResults : actuacionesContractuales;
  }
);

export const selectActuacionContractualById = (id: number) =>
  createSelector(selectAllActuacionesContractuales, actuacionesContractuales =>
    actuacionesContractuales.find(ac => ac.actuacionId === id)
  );

export const selectActiveActuacionesContractuales = createSelector(
  selectAllActuacionesContractuales,
  actuacionesContractuales => actuacionesContractuales.filter(ac => ac.estado)
);

export const selectInactiveActuacionesContractuales = createSelector(
  selectAllActuacionesContractuales,
  actuacionesContractuales => actuacionesContractuales.filter(ac => !ac.estado)
);
